import React from 'react';

import StoryDataTable from '../components/DataTable/StoryDataTable';
import PageFrame from '../layouts/PageFrame';

export default function StoryList({
    type, tag, project, location,
}) {
    return (
        <PageFrame type={type}>
            <StoryDataTable
                key={type}
                type={type}
                tag={tag}
                project={project}
                location={location}
            />
        </PageFrame>
    );
}
